var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedLuggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4193_2834)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5999 1.8V4.79995H14.1999V1.8H10.5999ZM8.79995 1.2V4.79995H6.4C5.07452 4.79995 4 5.87447 4 7.19995V20.3999C4 21.7254 5.07452 22.7999 6.4 22.7999H7.59999V22.8C7.59999 23.4628 8.13725 24 8.79999 24C9.46273 24 9.99999 23.4628 9.99999 22.8V22.7999H14.8V22.8C14.8 23.4628 15.3372 24 16 24C16.6627 24 17.2 23.4628 17.2 22.8V22.7999H18.4C19.7255 22.7999 20.8 21.7254 20.8 20.3999V7.19995C20.8 5.87447 19.7255 4.79995 18.4 4.79995H15.9999V1.2C15.9999 0.537258 15.4627 0 14.7999 0H9.99995C9.33721 0 8.79995 0.537258 8.79995 1.2ZM6.4 6.59995H9.98919L9.99995 6.6H14.7999L14.8107 6.59995H18.4C18.7314 6.59995 19 6.86858 19 7.19995V20.3999C19 20.7313 18.7314 20.9999 18.4 20.9999H6.4C6.06863 20.9999 5.8 20.7313 5.8 20.3999V7.19995C5.8 6.86858 6.06863 6.59995 6.4 6.59995ZM12.4 8.40001C11.9029 8.40001 11.5 8.80295 11.5 9.30001V18.3C11.5 18.7971 11.9029 19.2 12.4 19.2C12.897 19.2 13.3 18.7971 13.3 18.3V9.30001C13.3 8.80295 12.897 8.40001 12.4 8.40001ZM7.59999 9.30001C7.59999 8.80295 8.00294 8.40001 8.49999 8.40001C8.99705 8.40001 9.39999 8.80295 9.39999 9.30001V18.3C9.39999 18.7971 8.99705 19.2 8.49999 19.2C8.00294 19.2 7.59999 18.7971 7.59999 18.3V9.30001ZM16.3001 8.40001C15.803 8.40001 15.4001 8.80295 15.4001 9.30001V18.3C15.4001 18.7971 15.803 19.2 16.3001 19.2C16.7971 19.2 17.2001 18.7971 17.2001 18.3V9.30001C17.2001 8.80295 16.7971 8.40001 16.3001 8.40001Z",
    fill: "#7E8A96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4193_2834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedLuggage);
export default __webpack_public_path__ + "static/media/checked-luggage.b1debe12.svg";
export { ForwardRef as ReactComponent };